// ToasterConsultantTemplateFill.jsx - Updated Main Component
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// ----------------- React Icons Imports -----------------
import { LiaSpinnerSolid } from "react-icons/lia";

// ----------------- Assets Imports -----------------
import blueKbcLogo from '../../../assets/images/branding/blue-kbc-logo.png';

// --------------------- CSS File --------------------
import '../../../assets/css/ShePack.css';
import ItemRemovedToaster from '../../toasterscomponents/checklistToasters/ItemRemovedToaster';

// --------------------- Component Imports ---------------------
import ItemAddedToaster from '../../toasterscomponents/checklistToasters/ItemAddedToaster';
import CreatedSuccesFullyToaster from '../../toasterscomponents/shepacktoasters/CreatedSuccesFullyToaster';

// ----------------- Section Imports -----------------
import SectionA from './ToasterFillInTableAandB/ToasterConsultantTableA';
import SectionB from './ToasterFillInTableAandB/ToasterConsutlanttableB';

// ----------------- Main Component -----------------
const ToasterConsultantTemplateFill = ({ 
  isOpen, 
  onClose,
  selectedSheFileId,
  selectedSheFileName,
  selectedSheFileUserScore,
  onScoreUpdate,
  selectedSheFileScore,
  templates,
  setTemplateResponses,
  isLoading,
  selectedCompany,
  selectedCompanyName,
  selectedDepartmentName,
  selectedDepartment,
  onSave,
  onRefreshTemplates
}) => {

  const navigate = useNavigate();

  // ------------------ State Management -------------------
  const [templateErrors, setTemplateErrors] = useState({});
  const [employeeErrors, setEmployeeErrors] = useState({});
  const [expiryDates, setExpiryDates] = useState({});
  const [employeeFileExpiryDate, setEmployeeFileExpiryDate] = useState({});
  const [periodSelections, setPeriodSelections] = useState({});
  const [showToaster, setShowToaster] = useState({ 
    success: false, 
    fileChanged: false, 
    employeeFileChanged: false, 
    rowRemoved: false, 
    optionAdded: false, 
    editedCategory: false, 
    cancelEditedCategory: false, 
    fileSelected: false,
    fileSaved: false,
    fileSavedError: false,
    periodError: false,
    errrorToaster: false,
    templateSubmitted: false
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [expandedDocuments, setExpandedDocuments] = useState({});
  const [expandedPreviewPhotos, setExpandedPreviewPhotos] = useState({});
  const [formSubmissionError, setFormSubmissionError] = useState('');
  const [files, setFiles] = useState({});
  const [previewPhotos, setPreviewPhotos] = useState({});
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [manualUploadTemplate, setManualUploadTemplate] = useState(null);
  const [userScore, setUserScore] = useState({});
  const [userTemplateScore, setUserTemplateScore] = useState({});
  const [userTemplatePercentage, setUserTemplatePercentage] = useState({});
  const [totalCalculatedScore, setTotalCalculatedScore] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');

  const user = JSON.parse(sessionStorage.getItem('user'));

  /*-----------------------------------------------------------------
                            Use Effects 
  ---------------------------------------------------------------*/

  useEffect(() => {
    const initialUserScores = {};
    templates.forEach(template => {
      if (template.user_template_score) {
        initialUserScores[template.template_id] = parseFloat(template.user_template_score);
      }
    });
    setUserScore(initialUserScores);
    
    const initialTotal = templates.reduce((total, template) => {
      return total + (parseFloat(template.user_template_score || 0));
    }, 0);
    
    if (!totalCalculatedScore && initialTotal > 0) {
      setTotalCalculatedScore(initialTotal);
    }
  }, [templates]);

 

  useEffect(() => {
  templates.forEach(document => {
    
    // Keep only this part for regular templates:
    if (document.user_score > 0) {
      const percentage = (document.template_score / document.user_score) * 100;
      setUserTemplatePercentage(prev => ({
        ...prev,
        [document.template_id]: percentage.toFixed(2)
      }));
    }
  });
}, [templates]); // Remove totalEmployeeScore from dependencies

  useEffect(() => {
    const timers = Object.keys(showToaster).map(key => showToaster[key] && setTimeout(() => setShowToaster(prev => ({ ...prev, [key]: false })), 3000));
    return () => timers.forEach(timer => clearTimeout(timer));
  }, [showToaster]);


  /*------------------------------------------------------------
                            Functions
  ------------------------------------------------------------*/

  const clearTemplateError = (templateId) => {
    setTemplateErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[templateId];
      return newErrors;
    });
  };

 

  const openFullScreenImage = (imageUrl) => {
    setFullScreenImage(imageUrl);
  };

  const closeFullScreenImage = () => {
    setFullScreenImage(null);
  };

  const calculateExpiryDate = (selectedDate, frequency) => {
    if (!selectedDate || !frequency) return null;
    
    try {
      const startDate = new Date(selectedDate);
      let expiryDate = new Date(startDate);
      
      switch (frequency) {
        case 'Weekly':
          expiryDate.setDate(startDate.getDate() + 7);
          break;
        case 'Monthly':
          expiryDate.setMonth(startDate.getMonth() + 1);
          break;
        case 'Quarterly':
          expiryDate.setMonth(startDate.getMonth() + 3);
          break;
        case 'Bi-Annually':
        case 'Bi-annual':
          expiryDate.setMonth(startDate.getMonth() + 6);
          break;
        case 'Annually':
        case 'Yearly':
          expiryDate.setFullYear(startDate.getFullYear() + 1);
          break;
        case 'When-Required':
          expiryDate.setDate(startDate.getDate() + 1);
          break;
        default:
          return null;
      }
      
      return expiryDate;
    } catch (error) {
      console.error('Error calculating expiry date:', error);
      return null;
    }
  };

  const formatDateForDatabase = (date) => {
    if (!date) return null;
    
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (id, e) => {
    const selectedDate = e.target.value;
    
    setPeriodSelections(prev => ({
      ...prev,
      [id]: selectedDate
    }));
    
    let templateFrequency = null;
    
    if (id.includes('-')) {
      const templateId = id.split('-')[0];
      const template = templates.find(t => t.template_id == templateId);
      templateFrequency = template?.template_frequency;
    } else {
      const template = templates.find(t => t.template_id == id);
      templateFrequency = template?.template_frequency;
    }
    
    if (templateFrequency && selectedDate) {
      const expiryDate = calculateExpiryDate(selectedDate, templateFrequency);
      
      setExpiryDates(prev => ({
        ...prev,
        [id]: expiryDate
      }));
    }
  };

  const openPdfInNewTab = (file) => {
    const fileUrl = URL.createObjectURL(file);
    window.open(fileUrl, '_blank');
  };

  const handleRemoveFile = (documentId) => {
    setPreviewPhotos(prev => {
      const newPreviewPhotos = { ...prev };
      delete newPreviewPhotos[documentId];
      return newPreviewPhotos;
    });
    setExpandedPreviewPhotos(prev => {
      const newExpandedPreviewPhotos = { ...prev };
      delete newExpandedPreviewPhotos[documentId];
      return newExpandedPreviewPhotos;
    });
    
   
  };

  const togglePreviewExpanded = (documentId) => {
    setExpandedPreviewPhotos(prev => ({
      ...prev,
      [documentId]: !prev[documentId]
    }));
  };

  const handleFileChange = (templateId, event) => {
    const file = event.target.files[0];
    clearTemplateError(templateId);
    
    if (file) {
      console.log('File selected:', file);
      
      if (file.size <= 10 * 1024 * 1024) {
        setFiles(prev => ({ 
          ...prev, 
          [templateId]: file 
        }));
        
        if (file.type.startsWith('image/')) {
          setPreviewPhotos(prev => ({
            ...prev,
            [templateId]: URL.createObjectURL(file)
          }));
        } else if (file.type === 'application/pdf') {
          setPreviewPhotos(prev => ({
            ...prev,
            [templateId]: 'PDF_FILE'
          }));
        }

        setShowToaster(prev => ({ ...prev, fileChanged: true }));
      } else {
        setErrorMessage('File size exceeds 10MB limit.');
        event.target.value = '';
      }
    }
  };



  if (!isOpen) return null;

  return (
    <div className="checklist-question-user-fill-in-checklist-main-container">
      <div className="template-question-fill-in-checklist-container">
        <div className="template-fill-in-elements-container">
          <div className="user-fill-in-back-button-time-container">
            <div className='user-fill-in-back-button-container'>
              <img src={blueKbcLogo} alt="white-kbc-logo" className="add-quesiton-side-menu-logo" />
              <button type="button" onClick={onClose} className="user-fill-in-back-button">Back</button>
            </div>
          </div>
          
          <div>
            <div className="compliance-tracker-consultant-fill-in-header-main-container">
              <div className="Template-fill-in-header-text-main-container">
                <div>
                  <h2>Compliance Tracker - <span className="secondary-color-paragraph">Consultant Fill In Template</span></h2>
                </div>
                <div>
                  <h3>SHE File: <span style={{ color: 'black' }}>{selectedSheFileName}</span></h3>
                </div>
              </div>
                
              <div>
                <div>
                  <p>Company <span className="secondary-color-paragraph">{selectedCompanyName}</span>, Department <span className="secondary-color-paragraph">{selectedDepartmentName}</span></p>
                </div>
                <h2>
                  <span className="secondary-color-paragraph">
                    Provisional SHE File Score: <br/> {selectedSheFileUserScore || 0} /{selectedSheFileScore}
                  </span>
                </h2>
              </div>
            </div>

            {isLoading ? (
              <div className="loading-spinner-container">
                <LiaSpinnerSolid className="lia-spin-solid-icon" />
              </div>
            ) : (
              <>
                
                {/* Tables - Section A (Template Submissions)
                  This table is used for consultant template submissions
                */}

                <SectionA
                  templates={templates}
                  isLoading={isLoading}
                  files={files}
                  previewPhotos={previewPhotos}
                  expandedPreviewPhotos={expandedPreviewPhotos}
                  periodSelections={periodSelections}
                  expiryDates={expiryDates}
                  templateErrors={templateErrors}
                  userScore={userScore}
                 
                  selectedSheFileId={selectedSheFileId}
                  selectedSheFileName={selectedSheFileName}
                  selectedSheFileScore={selectedSheFileScore}
                  selectedCompany={selectedCompany}
                  selectedCompanyName={selectedCompanyName}
                  selectedDepartment={selectedDepartment}
                  selectedDepartmentName={selectedDepartmentName}
                  setUserScore={setUserScore}
                  setUserTemplatePercentage={setUserTemplatePercentage}
                  setTotalCalculatedScore={setTotalCalculatedScore}
                  setErrorMessage={setErrorMessage}
                  setShowToaster={setShowToaster}
                  clearTemplateError={clearTemplateError}
                  setTemplateErrors={setTemplateErrors}
                  handleFileChange={handleFileChange}
                  handleDateChange={handleDateChange}
                  handleRemoveFile={handleRemoveFile}
                  togglePreviewExpanded={togglePreviewExpanded}
                  openFullScreenImage={openFullScreenImage}
                  openPdfInNewTab={openPdfInNewTab}
                  onSave={onSave}
                  onRefreshTemplates={onRefreshTemplates}
                  formatDateForDatabase={formatDateForDatabase}
                />

                {/* Tables - Section B (Employee Medicals)
                  This table is used for employee medical submissions
                */}
                
                <SectionB
                  templates={templates}
                  selectedCompanyName={selectedCompanyName}
                  selectedDepartmentName={selectedDepartmentName}
                  selectedSheFileId={selectedSheFileId}
                  selectedSheFileName={selectedSheFileName}
                  selectedSheFileScore={selectedSheFileScore}
                  selectedCompany={selectedCompany}
                  selectedDepartment={selectedDepartment}
                  userScore={userScore}
                  totalCalculatedScore={totalCalculatedScore}
                  setTotalCalculatedScore={setTotalCalculatedScore}
                  setShowToaster={setShowToaster}
                  openFullScreenImage={openFullScreenImage}
                  openPdfInNewTab={openPdfInNewTab}
                  onSave={onSave}
                  onRefreshTemplates={onRefreshTemplates}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {/* Full Screen Image Modal */}
      {fullScreenImage && (
        <div 
          className="full-screen-image-overlay" 
          onClick={closeFullScreenImage}
        >
          <div className="full-screen-image-container">
            <img 
              src={fullScreenImage} 
              alt="Full Screen Preview" 
              className="full-screen-image"
              onClick={(e) => e.stopPropagation()} 
            />
            <button 
              className="close-image-modal-btn" 
              onClick={closeFullScreenImage}
            >
              &times;
            </button>
          </div>
        </div>
      )}

      {/* Toasters */}
      {showToaster.fileChanged && <ItemAddedToaster item={'File Uploaded'} />}
      {showToaster.employeeFileChanged && <ItemAddedToaster item={'Employee File Uploaded'} />}
      {showToaster.fileSaved && <ItemAddedToaster item={'File Saved'} />}
      {showToaster.fileSavedError && <ItemRemovedToaster item={'Error While Saving File'} />}
      {showToaster.periodError && <ItemRemovedToaster item={'Error - File Upload Period'} />}
      {showToaster.errrorToaster && <ItemRemovedToaster item={'File Removed Deleted'} />}
      {showToaster.rowRemoved && <ItemRemovedToaster item={'File Removed Deleted'} />}
      {showToaster.templateSubmitted && <ItemAddedToaster item={'Template Submitted Successfully'} />}

      {showSuccess && 
        <CreatedSuccesFullyToaster
          heading='SHE File Submitted Successfully'
        />
      }
    </div>
  );
};

export default ToasterConsultantTemplateFill;